import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ErrorOutlined } from "@mui/icons-material";

export function PageNotFound() {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                minHeight: "calc(100vh - 250px)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                gap: 2,
                bgcolor: "background.default",
                color: "text.primary",
                p: 3
            }}
        >
            <ErrorOutlined sx={{ fontSize: 80, color: "error.main" }} />
            <Typography variant="h3" fontWeight={600}>
                404 - Page Not Found
            </Typography>
            <Typography variant="body1" color="text.secondary" maxWidth="sm">
                The page you’re looking for doesn’t exist or you dont have
                access to it.
            </Typography>
            <Button
                variant="contained"
                color="primary"
                onClick={() => navigate("/")}
                sx={{ mt: 2 }}
            >
                Go Back Home
            </Button>
        </Box>
    );
}
